import { Box } from "@mui/material"
import { useStyles } from "./styles"
import { BreadCrumb } from "../../../../components"
import { CustomePanel, CustomeTab } from "../../../../components/customeTab"
import { TabsItemFiles } from "../../utils/enums/tabs"
import { useTranslation } from "react-i18next"
import { ListTabItem } from "../../../../components/customeTab/types"
import { useContext } from "react"
import { FilesManagerContext } from "../../context"
import { AllFiles } from "./components/allFiles"
import { UserFiles } from "./components/userFiles"



export const FilesManager = () => {

    const styles = useStyles()
    const { t } = useTranslation()

    const tabs: ListTabItem[] = [
        {
            id: TabsItemFiles.ALL_FILES,
            label: t('filesManager.tabs.allFiles'),
            value: TabsItemFiles.ALL_FILES
        },
        {
            id: TabsItemFiles.USERS_WITH_FILES,
            label: t('filesManager.tabs.usersWithFiles'),
            value: TabsItemFiles.USERS_WITH_FILES
        },
    ]


    const { setTabValue, tabValue } = useContext(FilesManagerContext)

    const changeTab = ({ value }: { value: TabsItemFiles }) => {
        setTabValue(value)
    }

    return (
        <Box sx={styles.container}>
            <BreadCrumb
                removeBreadcrumb={['filesManager']}
                replaceLabels={{ main: 'filesManager' }}
            />

            <CustomeTab
                listTab={tabs}
                value={tabValue}
                justifyContent="start"
                tabList={{ onChange: (_, value) => { changeTab({ value }) } }}
            >
                <CustomePanel value={TabsItemFiles.ALL_FILES}> <AllFiles /> </CustomePanel>
                <CustomePanel value={TabsItemFiles.USERS_WITH_FILES}> <UserFiles /> </CustomePanel>
            </CustomeTab>
        </Box>
    )
}